import React from 'react';
import { Typography } from 'antd';
import type { CompletionReadinessItem } from './dispatcherContextProjection';

const { Text } = Typography;

type Props = {
  items: CompletionReadinessItem[];
  onOpenCompletion?: () => void;
};

export const CompletionReadinessStrip: React.FC<Props> = ({ items, onOpenCompletion }) => {
  if (items.length === 0) return null;

  return (
    <section className="execution-workspace__completion-hints">
      <div className="execution-workspace__section-title">Перед завершением</div>
      <ul className="execution-workspace__completion-list">
        {items.map((item) => (
          <li
            key={item.id}
            className={
              item.severity === 'warning'
                ? 'execution-workspace__completion-item--warning'
                : 'execution-workspace__completion-item--info'
            }
          >
            {item.label}
          </li>
        ))}
      </ul>
      {onOpenCompletion ? (
        <Text
          type="secondary"
          style={{ fontSize: 11, cursor: 'pointer', textDecoration: 'underline' }}
          onClick={onOpenCompletion}
        >
          Открыть завершение маршрута →
        </Text>
      ) : null}
    </section>
  );
};

export default CompletionReadinessStrip;
